import { render } from "./IndexPcPage.vue?vue&type=template&id=13cd71f5&scoped=true"
import script from "./IndexPcPage.vue?vue&type=script&lang=js"
export * from "./IndexPcPage.vue?vue&type=script&lang=js"

import "./IndexPcPage.vue?vue&type=style&index=0&id=13cd71f5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cd71f5"]])

export default __exports__